<template>
    <div class="d-flex flex-column">
        <div class="w-50 mobile-w-100  mobile-order" style="height: 100%; display: block;">
            <div class="d-flex text-center align-items-center justify-center align-center bienvenido-corchete"  >
                <img  class="mobile-content-img content-img " alt="">
                <div  class="d-flex flex-column mobile-title">
                    <div class="mx-auto leon-mobile" style="width:6vw">
                        <img src="@/assets/img/leon1.png" width="100%" class="mx-auto" >
                    </div>
                    <router-link  class="no-decoration" to="/">
                        <div class="text-uppercase font-weight-bold bienvenido "  style="">Bienvenido</div>
                        <span class="text-uppercase tramites" style="">TRÁMITES</span>
                    </router-link>
                </div>
            </div>
        </div>
        <div  class="d-flex mobile-card-placement" style="height:100vh;">     
            <v-row  style="z-index:10;width:100%;justify-content:center"   >
                <v-col cols="12" md="6" lg="6"  class="display-none" ></v-col>
                <v-col cols="12" md="12" lg="6" class="d-flex flex-column  flex-wrap justify-center align-content-center unset-center-mobile " >
                    
                    <v-card class="pa-6 "  plain flat  max-width="570px" width="100%" >
                        <router-link to="/">
                            <v-img class="logo_tam logo_genl display-none" alt="Logo" src="../../assets/img/logo_genl.png"></v-img>
                        </router-link>
                        <v-card-title class="justify-center text-h5 text-center pb-6 " style="color:#ff8400;word-break: break-word;" >Ingrese su nombre de usuario y contraseña</v-card-title>

                        <v-card-text>
                            <!-- LOGIN FORM -->
                            <v-form align="center" ref="loginForm" v-model="formValid" lazy-validation>
                                <!--<v-text-field
                                    class=""
                                    label="Usuario" outlined
                                    :rules="[rules.username.required]"
                                    v-model="loginRequest.username"
                                    autofocus>
                                </v-text-field>-->
                               <v-text-field 
                                    class=""
                                    outlined
                                    placeholder="Teléfono/Correo/Usuario"
                                    :rules="[rules.username.required]"
                                    v-model="loginRequest.username"
                                    >
                               </v-text-field>
                              <v-text-field
                                    class=""
                                    outlined
                                    placeholder="Contraseña"
                                    :rules="[rules.password.required]"
                                    v-model="loginRequest.password"
                                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                    :type="showPassword? 'text' : 'password'"
                                    @click:append="showPassword = !showPassword"

                                    @keyup.enter.prevent="doLogin"
                                    

                                ></v-text-field>

                                
                                <div class="d-flex flex-column">
                                    <v-btn text color="#ff8400" small  class="text-none text-decoration-none" large  @click.stop="recoverPassword = true" >
                                        ¿Olvidó su contraseña?
                                    </v-btn>

                                    <v-btn :color="color" class="white--text text-h6 v-btn-height"  style="border-radius:10px" large @click="doLogin">iniciar sesion</v-btn>

                                    <!-- <v-divider class="my-4"></v-divider> -->
                                    
                                </div>
                              

                            </v-form>
                                <!-- <div class="text-center my-4">
                                    <span class="mb-2  mr-2 " >Entrar con: </span>
                                    <v-btn class="white--text mr-2 relative" color="#0D47A1">
                                        <v-icon left>mdi-facebook</v-icon> Facebook
                                        <facebook-login :key="fbComponentKey" class="fb-native-button absolute"
                                                        logoutLabel=""
                                                        loginLabel=""
                                                        :appId="getFacebookId()"
                                                        @login="onFacebookLogin"
                                                        @logout="onFacebookLogout"
                                                        @get-initial-status="onFacebookLogin">
                                        </facebook-login>
                                    </v-btn>

                                    <v-btn color="deep-orange" class="white--text ">
                                        <v-icon left>mdi-google</v-icon>
                                        <GoogleLogin
                                            :params="{client_id: getGoogleClientId()}"
                                            :onSuccess="onSuccessAuthGoogle"
                                            :onFailure="onGoogleLoginFailure"
                                        >Google
                                        </GoogleLogin>

                                    </v-btn>

                                </div> -->

                            <v-divider class="mt-2"></v-divider>
                            
                            <div class="d-flex flex-column mb-6">
                                    <span class="mb-6 my-10 mx-auto" style="color:#ff8400">¿Aún no tienes usuario?</span>
                                    <v-row align="center" justify="space-around">
                                        <v-btn  :to="{ name: 'register' }" large outlined width="60%" class="text-h6 v-btn-height " style="border-radius:5px;font-weight:1000;">
                                            Registrate
                                        </v-btn>
                                    </v-row>
                            </div>

                        </v-card-text>

                    </v-card>
                </v-col>

                <v-dialog v-model="recoverPassword" max-width="800">
                    <v-card height="" class="d-flex flex-column pb-5">
                        <v-card-title :color="pantone" class="headline mx-auto my-3 text-center text-uppercase" v-bind:style="{color : pantone, 'word-break': 'break-word' }">Recuperar contraseña</v-card-title>
                        <v-divider class=""></v-divider>
                        <v-form class=" d-flex flex-column justify-center  mx-auto mt-4" @submit="doLogin">

                            <v-card-text class="d-flex  flex-column justify-center montserrat">
                                <span class="mx-auto text-center" style="width:75%;font-size: .8rem">  Captura el número de teléfono o correo con el que registraste tu cuenta </span>

                                <v-text-field
                                        class="mt-5 mx-4"
                                        outlined required v-model="forgotPwdPhone"
                                        placeholder="Ej: 5536658963 (10 digitos)"
                                        :rules="rulesAux()"
                                        type="phone"
                                        width="50%"
                                        autofocus
                                />
                            </v-card-text>

                            <v-row  style="width:95%;margin: auto"  justify="center">
                                <!-- <v-btn :color="pantoneBlack" class="white--text flex-fill mr-2 " @click="recoverPassword = false">
                                    Cancelar
                                </v-btn> -->
                                <v-btn :color="pantoneBlack" class="white--text flex-fill mx-4 " @click="forgotPasswordSend()">
                                    Enviar
                                </v-btn>
                            </v-row>
                        </v-form>
                    </v-card>
                </v-dialog>
                <img  class="marca-awa"  src="@/assets/img/logo_circular_bco.png" alt="">
            </v-row>
        </div>
        <div class="fondo-login"></div>
    </div>

</template>

<script>
import {mapActions, mapState} from 'vuex'
import {loginRequestModel} from "bestgob-core/api/models";
import {parsedFacebookUserData, parsedGoogleUserData} from "bestgob-core/core/utils";

// import GoogleLogin from 'vue-google-login';
// import facebookLogin from 'facebook-login-vuejs';

/*import Vue from 'vue';
Vue.forceUpdate();*/

  export default {
      components: {
        //   GoogleLogin, facebookLogin
      },
      data() {
          return {
              renderParams: {
                  width: 250,
                  height: 50,
                  longtitle: true
              },
              recoverPassword: false,
              rules: {
                  email: {
                      required: value => !!value || 'El campo Email es requerido.',
                      valid_email: v => /\S+@\S+\.\S+/.test(v) || 'El email no es válido'
                  },
                  username: {
                      required: value => !!value || 'El campo Teléfono/Correo/Usuario es requerido.',
                  },
                  phone: {
                      required: value => !!value || 'El campo Teléfono/Correo es requerido.',
                      digits_10: v => (!!v && v.length === 10) || 'El número de teléfono debe ser de 10 dígitos',
                      valid_email: v => /\S+@\S+\.\S+/.test(v) || 'El email no es válido',
                      isNumber: v => !isNaN(v) || 'Solo se aceptan caracteres numéricos'
                  },
                  password: {
                      required: value => !!value || 'El campo Contraseña es requerido.',
                  }
              },

              formValid: false,
              showPassword: false,
              loginRequest: loginRequestModel(),
              FB: undefined,
              isConnected: false,

              fbComponentKey: 0,

              forgotPwdPhone: null,
              color: '#15212F',
              pantone: '#B08C55',
              pantoneBlack: '#15212F'

          }
      },
      computed: {
          ...mapState({accountStore: state => state.account}),
      },

      created() {
          this.$gtag.event('iniciar_sesion', { method: 'Google' }) // Google Analytics

      },

      methods: {
          ...mapActions('account', ['login', 'loginOrRegisterWithGoogle', 'loginOrRegisterWithFacebook',
              'clearGoogleLogin', 'saveFacebookSession', 'requestForgotPassword']),

          doLogin(){
              this.$refs.loginForm.validate()
              if (this.formValid){
                  this.login(this.loginRequest)
              }
          },

          rulesAux(){
              if( !isNaN(this.forgotPwdPhone) ){
                return [this.rules.phone.required, this.rules.phone.isNumber, this.rules.phone.digits_10 ]
              }else{
                return[this.rules.phone.required, this.rules.phone.valid_email]
              }
          },

          onSuccessAuthGoogle(googleUser) {
              let googleUserData = parsedGoogleUserData(googleUser)
              this.loginOrRegisterWithGoogle(googleUserData)
          },

          onGoogleLoginFailure(error) {
              console.log(error);
          },

          async onFacebookLogin(data){
              this.saveFacebookSession(data.FB)
              if (data.response){
                 this.getFacebookUserData()
              }
          },

          getFacebookUserData() {
              this.accountStore.FB.api('/me', 'GET', { fields: 'id,first_name,last_name,email,picture' }, user => {
                  let facebookLoginData = parsedFacebookUserData(user)
                  this.loginOrRegisterWithFacebook(facebookLoginData)
              })
          },

          onFacebookLogout(data){
              console.log(data)
          },

          getGoogleClientId(){
              return process.env.VUE_APP_GOOGLE_CLIENT_ID
          },

          getFacebookId(){
              return process.env.VUE_APP_FACEBOOK_ID
          },

          forgotPasswordSend(){
              let urlForm = window.location.origin + this.$router.resolve({name: 'forgot_password'}).href

              let request = {
                  dato: this.forgotPwdPhone, url_form: urlForm,
                  client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID
              }

              this.requestForgotPassword(request)
              this.recoverPassword = false
          }
      },

      mounted() {
          if (this.accountStore.loggedIn){
              this.$router.push({name: 'home'})
          }

          //If redirection is from Register google/facebook user
          if (this.accountStore.googleOrFBLoginData){
              this.login(this.accountStore.googleOrFBLoginData)
          }

          if (this.accountStore.FB){
              //this.accountStore.FB.init()
              this.accountStore.FB.logout()
              this.fbComponentKey += 1
          }
      }

  };
</script>
<style>

    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus, 
    input:-webkit-autofill:active{
        -webkit-box-shadow: 0 0 0 30px white inset !important;
    }
    .no-decoration{
        text-decoration: none !important;
    }
    .aux-mobile{
        z-index: 1
    }
    .not-on-desktop{
        display: none;
    }
    .tramites{
        z-index:20;
        font-size:3vw;
        color: #ff8400;
    }

    .bienvenido{
        z-index:20;
        font-size:5vw;
        color: #ff8400 ;
        height:5.4vw
    }
    
    .bienvenido-corchete{
        height: 95%;
        width:52%;
        position:absolute;
        left:0;
        z-index:2
    }

    .marca-awa{
        position: absolute;
        right: 5%;
        bottom: 2rem;
        width: 150px;
        height: 150px;
    }
    .montserrat{
        font-family: "Montserrat" !important;
    }

    .v-application.fondo_login fieldset{
        border-bottom: 0px !important
    }
    /* .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot{
        min-height: unset !important;
    } */

    .v-text-field--full-width .v-input__prepend-outer, .v-text-field--full-width .v-input__prepend-inner, .v-text-field--full-width .v-input__append-inner, .v-text-field--full-width .v-input__append-outer, .v-text-field--enclosed .v-input__prepend-outer, .v-text-field--enclosed .v-input__prepend-inner, .v-text-field--enclosed .v-input__append-inner, .v-text-field--enclosed .v-input__append-outer{
        margin-top: 0 !important;
    }

    .v-text-field--focused{
        transition: unset !important;   
    }

    /* .v-input__slot{
        align-items: center;
        color: inherit;
        display: flex;
        min-height: inherit;
        padding: .9rem  1rem !important;
        font-size: 1.25rem;
        line-height: 1.5;
        border-radius: 10px;
        display: flex;
        width: 100%;
        color: #ff8400 !important;
        background-color: #fff !important;
        background-clip: padding-box;
        border: 1px  solid #ff8400;
        border-radius: 0.25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }     */

    .relative {position: relative}
    .absolute {position: absolute}
    .fb-native-button{width: 100%;}
    .fb-native-button button{
        height: 36px;
        background-image: none !important;
        padding: 0 !important;
        min-width: 0 !important;
        width: 100%
    }
    .fb-native-button button img, .fb-native-button button .spinner{display: none}
    .outlined{
            border-radius: 4px;
            
    }
    
    .form-ejemplo{
       
    }
    .fondo-login{
        position: absolute;
        height: 51%;
        width: 100%;
        background-color: #fff5d3 !important;
        z-index: 0;
        bottom: 0;
        left: 0;
    }
    .content-img{
        max-width: 100%;
        min-width: 100%;
        height: auto;
        content: url("../../assets/img/corchete-bienvenido.svg");
    }
    .v-application .error--text{
        color: grey !important;
    }
    .theme--light.v-divider {
        border-color: #ff840059;
        height: 3px !important;
        border-width: thin 0px  1px  0px;
    }
    .mobile-title{
        position:absolute;
        margin-top:-4vw;
        margin-left: -3vw
    }

    @media only screen and (max-width: 1024px) {
        
        .aux-mobile{
            z-index: 11 !important
        }
        .not-on-desktop{
            display: inline-block;
        }
        .mobile-title{
            margin-top: 60vw;
        }
        .mobile-order{
            margin-top: -70%;
        }
        .marca-awa{
            position: absolute;
            right: 5%;
            bottom: 2rem;
            width: 100px;
            height: 100px;
        }
        .logo_genl{
            width: 100px !important;
        }

        .bienvenido-corchete{
            position: relative;
            width: 100%;
            z-index: 21;
        }

        .content-img{
            max-width: 107%;
            min-width: 107%;
            height: auto;
            content: url("../../assets/img/corchete-azul-11.svg")
        }
        .fondo-login{
            position: absolute;
            height: 21%;
            width: 100%;
            background-color: #fff !important;
            z-index: 0;
            bottom: 0;
            left: 0;
        }
        .v-card__title{
            padding: 2px
        }
        .v-card__text{
            padding: 0
        }
        .v-application .headline{
            font-size: 1rem !important;
            padding: 0 !important
        }

        .leon-mobile{
            width: 4rem !important;
        }

        .bienvenido{
            font-size:7vw;
            height:9vw;
            font-family: 'PoppinsMedium';
        }
        
        .tramites{
            z-index:20;
            font-size:3vw;
            color: #B08C55;
            letter-spacing: .3rem
            
        }
        .display-none{
            display: none;
        }
        .unset-center-mobile{
            margin-top: -15rem;
        }
    }

     @media only screen and (max-width: 774px) {
        .mobile-card-placement{
            height: 75vh !important;
        }
        .mobile-title{
            margin-top: 20vw;
        }
        .mobile-order{
            margin-top: -40%;
        }
        .leon-mobile{
            width: 2.5rem !important;
        }

        .bienvenido{
            font-size:9vw;
            height:12vw;
        }
        
        .tramites{
            z-index:20;
            font-size:5vw;
            color: #B08C55;
            letter-spacing: .3rem            
        }
        .display-none{
            display: none;
        }
        .unset-center-mobile{
            margin-top: -15rem;
        }
    }
    @media only screen and (max-width: 540px) {
        .unset-center-mobile{
            margin-top: 0rem;
        }
        .v-application .pa-6{
            padding: 0px !important;
        }
    }
</style>
